import { QUIZ_ATTEMPT_STATE_FIELDS } from "lib/experience-api/fragments";

export const GET_LATEST_QUIZ_ATTEMPT = `
  ${QUIZ_ATTEMPT_STATE_FIELDS}
  query GetLatestQuizAttempt($topicApiName: ID!) {
    getLatestQuizAttempt(topicApiName: $topicApiName) {
      ...QuizAttemptStateFields
    }
  }
`;
